module.exports = __webpack_public_path__ + "media/components/country-flag/static/ge-06c8d85118de1be6edddd26a739416a8.svg";